export class ImageBlockDetails {
    public imagePath: string;
    public align: number;
    public width: number;
    public height: number;
    
    public textLines?: string[];
    public textFormatting?: string[]; 
    public fontType?: number;
    public fontSize?: number;
    public barcode_type?: string;
    public textPosition?: string;
    public value?: string;
    public justification?: string;

    constructor(
        imagePath: string, 
        align: number, 
        width: number, 
        height: number, 
    ) {
        this.imagePath = imagePath;
        this.align = align;
        this.width = width;
        this.height = height;
    }
}